var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item,i){return [_c('app-list-item',{attrs:{"item":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }